var map = {
	"./404/ErrorPage": [
		"fTQd"
	],
	"./404/ErrorPage.vue": [
		"fTQd"
	],
	"./Home": [
		"j7e0"
	],
	"./Home.vue": [
		"j7e0"
	],
	"./frame/Footer": [
		"V6YO"
	],
	"./frame/Footer.vue": [
		"V6YO"
	],
	"./frame/GoBack": [
		"R0pV"
	],
	"./frame/GoBack.vue": [
		"R0pV"
	],
	"./frame/Header": [
		"m23R"
	],
	"./frame/Header.vue": [
		"m23R"
	],
	"./product/IntelligentWarehousing": [
		"TG6q"
	],
	"./product/IntelligentWarehousing.vue": [
		"TG6q"
	],
	"./product/Logistics": [
		"t5OW"
	],
	"./product/Logistics.vue": [
		"t5OW"
	],
	"./product/NetworkFreight": [
		"o8p5"
	],
	"./product/NetworkFreight.vue": [
		"o8p5"
	],
	"./public/AboutUs": [
		"crRX"
	],
	"./public/AboutUs.vue": [
		"crRX"
	],
	"./public/Customers": [
		"VSNQ"
	],
	"./public/Customers.vue": [
		"VSNQ"
	],
	"./public/Recruitment": [
		"Oqec"
	],
	"./public/Recruitment.vue": [
		"Oqec"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "MWF8";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/views lazy ^\.\/.*$
// module id = MWF8
// module chunks = 1